module.exports = __webpack_public_path__ + "img/bkl9.46b8db2e.jpg";